module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/map/marker-2-09dc5484847bcf0424f780d4c527f558.svg";